// import React, { useState } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { FaBars, FaHome, FaBlog, FaSignOutAlt ,FaUsers} from 'react-icons/fa';
// import { TbCategoryFilled } from "react-icons/tb";
// import { HiSpeakerphone } from "react-icons/hi";


// function SidebarCom() {
//   const [isOpen, setIsOpen] = useState(false);
//   const location = useLocation();

//   const toggleSidebar = () => {
//     setIsOpen(!isOpen);
//   };

//   const navItems = [
//     { path: '/', name: 'Dashboard', icon: <FaHome /> },
//     { path: '/users', name: 'User managment', icon: <FaUsers /> },
//     { path: '/vendor', name: 'Vendor managment', icon: <FaUsers /> },
//     { path: '/category', name: 'Category managment', icon: <TbCategoryFilled /> },
//     { path: '/ads', name: 'Ads managment', icon: <HiSpeakerphone /> },
//   ];

//   return (
//     <div className={`bg-gray-900 text-white ${isOpen ? 'w-64' : 'w-20'} min-h-screen transition-all duration-300 shadow-lg`}>
//       <div className="p-4 flex justify-between items-center">
//         <h1 className={`text-2xl font-bold transition-all duration-300 ${isOpen ? 'block' : 'hidden'}`}>Dashboard</h1>
//         <FaBars className="text-2xl cursor-pointer" onClick={toggleSidebar} />
//       </div>

//       <nav className="mt-10">
//         {navItems.map((item, index) => (
//           <Link
//             key={index}
//             to={item.path}
//             className={`flex items-center gap-4 p-4 text-lg hover:bg-gray-700 rounded-md transition-colors duration-300 ${location.pathname === item.path ? 'bg-gray-700' : ''}`}
//           >
//             <span className="text-xl">{item.icon}</span>
//             <span className={`${isOpen ? 'block' : 'hidden'} transition-all duration-300`}>{item.name}</span>
//           </Link>
//         ))}
//       </nav>

//       <div className="absolute bottom-4 left-4">
//         <Link to="/logout" className="flex items-center gap-4 p-4 text-lg hover:bg-red-600 rounded-md transition-colors duration-300">
//           <FaSignOutAlt className="text-xl" />
//           <span className={`${isOpen ? 'block' : 'hidden'} transition-all duration-300`}>Logout</span>
//         </Link>
//       </div>
//     </div>
//   );
// }

// export default SidebarCom;



import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaBars, FaHome, FaBlog, FaSignOutAlt, FaUsers } from 'react-icons/fa';
import { TbCategoryFilled } from "react-icons/tb";
import { HiSpeakerphone } from "react-icons/hi";
import { useDispatch } from 'react-redux';
import { exit_session } from '../../config/apiHandle';

function SidebarCom() {
  const [isOpen, setIsOpen] = useState(true);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const logoutHandle = ()=>{
    exit_session()
  }

  const navItems = [
    { path: '/', name: 'Dashboard', icon: <FaHome /> },
    { path: '/users', name: 'User managment', icon: <FaUsers /> },
    { path: '/vendor', name: 'Vendor managment', icon: <FaUsers /> },
    { path: '/category', name: 'Category managment', icon: <TbCategoryFilled /> },
    { path: '/ads', name: 'Ads managment', icon: <HiSpeakerphone /> },
  ];

  return (
    <div className={`bg-gray-900 text-white ${isOpen ? 'w-64' : 'w-20'} min-h-screen transition-all duration-300 shadow-lg`}>
      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg w-80">
            <h2 className="text-xl text-white mb-4">Are you sure you want to logout?</h2>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setShowLogoutModal(false)}
                className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={logoutHandle}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="p-4 flex justify-between items-center">
        <h1 className={`text-2xl font-bold transition-all duration-300 ${isOpen ? 'block' : 'hidden'}`}>Dashboard</h1>
        <FaBars className="text-2xl cursor-pointer" onClick={toggleSidebar} />
      </div>

      <nav className="mt-10">
        {navItems.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className={`flex items-center gap-4 p-4 text-lg hover:bg-gray-700 rounded-md transition-colors duration-300 ${location.pathname === item.path ? 'bg-gray-700' : ''}`}
          >
            <span className="text-xl">{item.icon}</span>
            <span className={`${isOpen ? 'block' : 'hidden'} transition-all duration-300`}>{item.name}</span>
          </Link>
        ))}
      </nav>

      <div className="absolute bottom-4 left-4">
        <div
          onClick={() => setShowLogoutModal(true)}
          className="flex items-center gap-4 p-2 text-lg hover:bg-red-600 rounded-md transition-colors duration-300 cursor-pointer"
        >
          <FaSignOutAlt className="text-xl" />
          <span className={`${isOpen ? 'block' : 'hidden'} transition-all duration-300`}>Logout</span>
        </div>
      </div>
    </div>
  );
}

export default SidebarCom;